import { cn } from '@/lib/utils';
import { Skeleton } from '@/components/ui/Skeleton.tsx';
import { Card } from '@/components/ui/Card.tsx';
import { StepHeaderSkeleton } from './stepSkeletonParts';
import { schedulePanelClass } from './settlementScheduleLayout.ts';

/** Krok W2 — rozliczenie różnicy. */
const ChangePackageSettlementStepSkeleton = ({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) => (
  <Card
    highlighted
    className={cn('@container overflow-hidden', className)}
    {...props}
  >
    <StepHeaderSkeleton />

    <div className="@max-[860px]:flex-col flex items-stretch">
      <div className="@min-[700px]:px-7 flex min-w-0 flex-1 flex-col gap-2.5 px-4 pb-[22px] pt-[18px]">
        {Array.from({ length: 3 }, (_, index) => (
          <Skeleton key={index} className="h-[74px] w-full rounded-[11px]" />
        ))}
        {/* Termin i metody płatności korekty — dwa pola pod wariantami. */}
        <div className="mt-1.5 flex gap-6">
          <Skeleton className="h-[52px] w-[168px]" />
          <Skeleton className="h-[52px] w-56" />
        </div>
      </div>

      <div className={schedulePanelClass}>
        <Skeleton className="h-3 w-48" />
        <div className="mt-3 flex flex-col gap-4">
          {Array.from({ length: 3 }, (_, index) => (
            <Skeleton key={index} className="h-10 w-full" />
          ))}
        </div>
        <Skeleton className="mt-5 h-6 w-full" />
      </div>
    </div>

    <div className="@min-[700px]:px-7 border-t border-neutral-200 px-4 pb-[22px] pt-6">
      <Skeleton className="h-3 w-72" />
      <div className="@max-[700px]:grid-cols-1 mt-3 grid grid-cols-2 gap-3">
        <Skeleton className="h-[104px] rounded-[11px]" />
        <Skeleton className="h-[104px] rounded-[11px]" />
      </div>
      <div className="mt-[18px] border-t border-neutral-200 pt-4">
        <Skeleton className="h-3 w-64" />
        <div className="mt-2.5 flex flex-col gap-4">
          {Array.from({ length: 4 }, (_, index) => (
            <Skeleton key={index} className="h-9 w-full" />
          ))}
        </div>
      </div>
    </div>

    <div className="@max-[940px]:flex-col @max-[940px]:items-stretch @min-[700px]:px-7 flex items-center gap-3.5 border-t border-neutral-100 px-4 pb-[22px] pt-[18px]">
      <Skeleton className="h-4 w-80 max-w-full" />
      <div className="@max-[940px]:ml-0 @max-[940px]:flex-col ml-auto flex shrink-0 gap-2.5">
        <Skeleton className="@max-[940px]:w-full h-11 w-28 rounded-[9px]" />
        <Skeleton className="@max-[940px]:w-full h-11 w-52 rounded-[9px]" />
      </div>
    </div>
  </Card>
);

export default ChangePackageSettlementStepSkeleton;
